import { memo } from 'react';
import { useParams } from 'react-router-dom';

import { useJourney } from 'api/journeys/hooks';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { JourneyStart } from './common';

type ActionType = 'journey_start';

export const Node = memo((node: JourneyNode<ActionType>) => {
  const { journeyId = '' } = useParams();
  const journeyQuery = useJourney(journeyId);

  if (!journeyQuery.isSuccess) {
    return null;
  }

  return (
    <NodeContainer hideTargetHandle node={node} disableClick>
      <JourneyStart node={node} />
    </NodeContainer>
  );
});
